import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { colors, fontSize } from '../../constants/styleConstants';
import StubPageSocialLinks from '../StubPageSocialLinks';
import ContactLinks from '../ContactLinks';
import { useTranslation } from '../../src/i18n';

const useStyles = makeStyles()({
  contactCard: {
    display: 'flex',
    flexDirection: 'column',
    padding: '5px 15px 15px 0',
    marginBottom: 20,
  },
  title: {
    fontSize: fontSize.medium,
    color: colors.grey3,
    lineHeight: 1.83,
    paddingBottom: '16px',
  },
});

const ContactCard = ({
  contacts,
  className,
  hideInfo,
  title,
  subTitle,
  socialLinksTitle,
  subTitleClass,
  cardClassName,
}) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();
  return (
    <>
      {contacts.length > 0 && (
        <div className={cx(classes.root, className)}>
          {title && title}
          <div className={cx(classes.contactCard, cardClassName)}>
            {subTitle && <div className={cx(classes.title, subTitleClass)}>{subTitle}</div>}
            <ContactLinks t={t} contacts={contacts} hideInfo={hideInfo} isProfileContact />
            <StubPageSocialLinks t={t} contacts={contacts} socialLinksTitle={socialLinksTitle} />
          </div>
        </div>
      )}
    </>
  );
};

ContactCard.propTypes = {
  contacts: PropTypes.array,
  className: PropTypes.string,
  hideInfo: PropTypes.bool,
  socialLinksTitle: PropTypes.string,
  subTitle: PropTypes.string,
};

export default ContactCard;
